package com.jet.classroomhero.usecases

import com.jet.classroomhero.data.ExtensionRepository
import com.jet.classroomhero.entities.Extension

class ExtensionUseCases(val repository: ExtensionRepository) {
  suspend fun getExtensions(): List<Extension> = repository.getExtensions(false)
  suspend fun activateExtension(classId: Int, extensionId: Int): Boolean = repository.activateExtension(classId, extensionId)
  suspend fun deactivateExtension(classId: Int, extensionId: Int): Boolean = repository.deactivateExtension(classId, extensionId)
}